<div class="home-container">
  @for (section of activeSections(); track section.id; let sectionIndex = $index) {
      @let sectionTitle = getSectionTitle(section);
      @let resourceRoute = getResourceRoute(section);
      @let auctionDisplayList = getAuctionDisplayList(section);
      @let sectionResourceCards = getSectionResourceCards(section);
      @let sectionCards = getSectionCards(section);
      <div class="home-section">
        @if (sectionTitle) {
          <div class="mx-5 d-flex justify-content-between align-items-center">
            <h3 class="home-auction-section__title">{{ sectionTitle }}</h3>

            @if (section.linkUrl) {
              <a [href]="section.linkUrl" class="home-auction-section__see-all">
                {{ 'IDS_SEE_MORE' | translate }}
              </a>
            } @else if (resourceRoute){
              <a [routerLink]="resourceRoute" class="home-auction-section__see-all">
                {{ 'IDS_SEE_MORE' | translate }}
              </a>
            }
          </div>
        }

        @if (section.sectionType === 'carousel') {
          <app-slideshow [carouselItems]="getSectionCarouselItems(section)" [isMobileView]="isMobileView()"
            [prioritizeInitialMedia]="sectionIndex === 0"></app-slideshow>
        } @else if ((section.sectionType === 'bid_showcase' || section.sectionType === 'selected_auctions') && auctionDisplayList.length > 0) {
          <app-bid-showcase [elementList]="auctionDisplayList" [displayInCarousel]="section.displayInCarousel"
            [stateKey]="'home-' + section.sectionType + '-' + section.id">
            <ng-template let-value pTemplate="item">
              <app-bid-element [auction]="value" [dark]="true" [minimal]="true"
                [eagerImage]="sectionIndex === 0"></app-bid-element>
            </ng-template>
          </app-bid-showcase>
        } @else if (section.sectionType === 'resource') {
          <app-bid-showcase [elementList]="getSectionAuctions(section)" [displayInCarousel]="section.displayInCarousel"
            [stateKey]="'home-' + section.sectionType + '-' + section.id">
            <ng-template let-value pTemplate="item">
              <app-bid-element [auction]="value" [dark]="true" [minimal]="true"
                [eagerImage]="sectionIndex === 0"></app-bid-element>
            </ng-template>
          </app-bid-showcase>
        } @else if (section.sectionType === 'resource_cards' && sectionResourceCards.length > 0) {
          <app-bid-showcase [elementList]="sectionResourceCards" [displayInCarousel]="section.displayInCarousel"
            [stateKey]="'home-' + section.sectionType + '-' + section.id">
            <ng-template let-card pTemplate="item">
              <div class="mx-1 element-dimensions">
                @if (getResourceCardRoute(card)) {
                <a [routerLink]="getResourceCardRoute(card)" class="home-resource-card-link home-resource-card-box">
                  <img class="home-resource-card-image" [src]="getResourceCardImageUrl(card)+'?w=400'" title="resource card"
                    [alt]="card.resourceLabel || 'resource card'" [attr.loading]="sectionIndex === 0 ? 'eager' : 'lazy'"
                    decoding="async" />
                </a>
                } @else {
                <div class="home-resource-card-box">
                  <img class="home-resource-card-image" [src]="getResourceCardImageUrl(card)+'?w=400'" title="resource card"
                    [alt]="card.resourceLabel || 'resource card'" [attr.loading]="sectionIndex === 0 ? 'eager' : 'lazy'"
                    decoding="async" />
                </div>
                }
              </div>
            </ng-template>
          </app-bid-showcase>
        } @else if (section.sectionType === 'cards' && sectionCards.length > 0) {
          <app-bid-showcase [elementList]="sectionCards" [displayInCarousel]="section.displayInCarousel"
            [stateKey]="'home-' + section.sectionType + '-' + section.id">
            <ng-template let-card pTemplate="item">
              <div class="mx-1 element-dimensions">
                <a [href]="card.url" class="home-resource-card-link home-resource-card-box">
                  <img class="home-resource-card-image" [src]="getSectionCardImageUrl(card)+'?w=400'" title="home card"
                    [alt]="card.title?.base || card.title?.it || card.title?.en || 'home card'"
                    [attr.loading]="sectionIndex === 0 ? 'eager' : 'lazy'" decoding="async" />
                </a>
              </div>
            </ng-template>
          </app-bid-showcase>
        }
      </div>
  }
</div>
